import { render, staticRenderFns } from "./PrivacyData.vue?vue&type=template&id=6c4c1cce&scoped=true"
import script from "./PrivacyData.vue?vue&type=script&lang=js"
export * from "./PrivacyData.vue?vue&type=script&lang=js"
import style0 from "./PrivacyData.vue?vue&type=style&index=0&id=6c4c1cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c1cce",
  null
  
)

export default component.exports